var base = require("./base");

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $("button.add-to-cart-global").attr("disabled", enableOrDisable);
}

$(".add-to-cart__container").on("click", (e) => {
    if ($(e.target).find(".add-to-cart").attr("disabled")) {
        $(".add-to-cart__error.not-ready-to-order").show();
    }
});

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements
    },

    availability: base.availability,

    addToCart: base.addToCart,

    updateAttributesAndDetails: function () {
        $("body").on("product:statusUpdate", function (e, data) {
            var $productContainer = $(".product-detail[data-pid=\"" + data.id + "\"]");

            $productContainer.find(".description-and-detail .product-attributes")
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find(".description-and-detail .description")
                    .removeClass("hidden-xl-down");
                $productContainer.find(".description-and-detail .description .content")
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find(".description-and-detail .description")
                    .addClass("hidden-xl-down");
            }

            if (data.longDescription) {
                $productContainer.find(".description-and-detail .details")
                    .removeClass("hidden-xl-down");
                $productContainer.find(".description-and-detail .details .content")
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find(".description-and-detail .details")
                    .addClass("hidden-xl-down");
            }
        });
    },

    showSpinner: function () {
        $("body").on("product:beforeAddToCart product:beforeAttributeSelect", function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $("body").on("product:afterAttributeSelect", function (e, response) {

            if (!$(".product-detail").hasClass("product-set-detail")) {
                if (response.arrayBasket.indexOf(response.productId) !== -1) {
                    $(this).find(".add-to-cart").addClass("d-none");
                    $(this).find(".go-to-cart").removeClass("d-none");
                } else {
                    $(this).find(".add-to-cart").removeClass("d-none");
                    $(this).find(".go-to-cart").addClass("d-none");
                }

            } else {
                $(".product-detail").each(function () {
                    if (response.data.product.id.split("/")[0] === response.data.masterP) {
                        if (response.arrayBasket.indexOf(response.productId) !== -1) {
                            $(this).find(".add-to-cart").addClass("d-none");
                            $(this).find(".go-to-cart").removeClass("d-none");

                        } else {
                            $(this).find(".add-to-cart").removeClass("d-none");
                            $(this).find(".go-to-cart").addClass("d-none");
                        }
                    }

                    if ($(this).data("pid") === response.productId) {
                        var figures = $(this).find(".product-visuals__wrapper figure");
                        for (var i = 0; i < figures.length; i++) {
                            var figure = figures[i];
                            var figureImg = $(figure).find("img");
                            if (response.data.product.images.large[i]) {
                                $(figure).attr("data-image", response.data.product.images.large[i].url);
                                $(figureImg).attr("src", response.data.product.images.large[i].url);
                                $(figureImg).attr("alt", response.data.product.images.large[i].alt);
                            }
                        }
                    }
                });
            }

            if ($(".product-detail>.bundle-items").length) {
                response.container.data("pid", response.data.product.id);
                response.container.find(".product-id").text(response.data.product.id);
            } else if ($(".product-set-detail").eq(0)) { // NOSONAR
                response.container.data("pid", response.data.product.id);
                response.container.find(".product-id").text(response.data.product.id);
            } else {
                $(".product-id").text(response.data.product.id);
                $(".product-detail:not(\".bundle-item\")").data("pid", response.data.product.id);
            }
        });
    },
    updateAddToCart: function () {
        $("body").on("product:updateAddToCart", function (e, response) {
            // update local add to cart (for sets)
            $("button.add-to-cart", response.$productContainer).attr(
                "disabled",
                (!response.product.readyToOrder || !response.product.available)
            );

            if (response.product.readyToOrder && response.product.available) {
                $(".add-to-cart__error.not-ready-to-order").hide();
            }

            if (response.product.available) {
                $(".add-to-cart__error.unavailable").hide();
            } else {
                $(".add-to-cart__error.unavailable").show();
            }

            var enable = $(".product-availability").toArray().every(function (item) {
                return $(item).data("available") && $(item).data("ready-to-order");
            });
            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
            module.exports.updateAttribute();
        });
    },
    updateAvailability: function () {
        $("body").on("product:updateAvailability", function (e, response) {
            $("div.availability", response.$productContainer)
                .data("ready-to-order", response.product.readyToOrder)
                .data("available", response.product.available);

            $(".availability-msg", response.$productContainer)
                .empty().html(response.message);

            if ($(".global-availability").length) {
                var allAvailable = $(".product-availability").toArray()
                    .every(function (item) { return $(item).data("available"); });

                var allReady = $(".product-availability").toArray()
                    .every(function (item) { return $(item).data("ready-to-order"); });

                $(".global-availability")
                    .data("ready-to-order", allReady)
                    .data("available", allAvailable);

                $(".global-availability .availability-msg").empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    sizeChart: function () {
        $(".size-chart a").on("click", function (e) {
            e.preventDefault();
            var url = $(this).attr("href");
            var $productSizeChartModal = $("#sizeChartDialog");
            var $prodSizeChart = $productSizeChartModal.find(".size-chart__content");

            if ($prodSizeChart.is(":empty")) {
                $.ajax({
                    url: url,
                    type: "get",
                    dataType: "json",
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                        $productSizeChartModal.appendTo("body");
                    }
                });
            }

            $productSizeChartModal.modal("show");
        });

        var $sizeChart = $(".size-chart-collapsible");
        $("body").on("click touchstart", function (e) {
            if ($(".size-chart").has(e.target).length <= 0) {
                $sizeChart.removeClass("active");
            }
        });
    },
    copyProductLink: function () {
        $("body").on("click", "#fa-link", function () {
            window.event.preventDefault();
            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val($("#shareUrl").val()).select();
            document.execCommand("copy");
            $temp.remove();
            $(".copy-link-message").attr("role", "alert");
            $(".copy-link-message").removeClass("d-none");
            setTimeout(function () {
                $(".copy-link-message").addClass("d-none");
            }, 3000);
        });
    },
    getNavHistory: function () {
        $(".breadcrumb__item").on("click", "a", function (e) {
            e.preventDefault();
            var windowLocation = sessionStorage.getItem("windowLocation");
            var catPathname = sessionStorage.getItem("catPathname");
            var thisLocation = window.location.href;

            if ($(this).attr("href") === catPathname) {
                sessionStorage.setItem("windowLocation", thisLocation);
                window.location.replace(windowLocation);
            }
        });

        $(window).on("popstate", function (e) {
            e.preventDefault();
            var windowLocation = sessionStorage.getItem("windowLocation");
            var catPathname = sessionStorage.getItem("catPathname");
            var thisLocation = window.location.href;

            if ($(this).attr("href") === catPathname) {
                sessionStorage.setItem("windowLocation", thisLocation);
                window.location.replace(windowLocation);
            }
        });
    },

    focusChooseBonusProductModal: base.focusChooseBonusProductModal()
};
